import refreshToken from './refreshToken'
export default ({ graphQLErrors, networkError }, nuxtContext) => {
  if (graphQLErrors) {
      // eslint-disable-next-line array-callback-return
      graphQLErrors.map(({ code, message, locations }) => {
          console.warn(
              `[GraphQL error]: Message: ${message}, Location: ${locations}`
          )
          if (code === 401) {
            refreshToken(nuxtContext).then(() => {
                console.log('token is refreshed')
            })
          }
      }
    )
  }
  if (networkError) {
    const message = networkError.message.split(': ')
    if (message[1] === 'Received status code 401') {
      refreshToken(nuxtContext)
    }
    // console.log(message[1])
  }
}
